module.exports = "/assets/efd78a6c1ea945f9a027e151243dd9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Y9.png
// module id = 2022
// module chunks = 0